import { render, staticRenderFns } from "./SystemWsod.vue?vue&type=template&id=6369568c&scoped=true&"
import script from "./SystemWsod.vue?vue&type=script&lang=js&"
export * from "./SystemWsod.vue?vue&type=script&lang=js&"
import style0 from "./SystemWsod.vue?vue&type=style&index=0&id=6369568c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369568c",
  null
  
)

export default component.exports